import { Facture } from '..';
import { QueovalBase } from '../global/class.global';

export class GestionFacturesModel extends QueovalBase {
  public ListFactures: Array<Facture>;
  public PathPdfMerged: string;
  public FileNamePdfMerged: string;
  public HasTokenAPI: boolean;
}



export class CommentFact {
  public StrIdentFact: string;
  public StrComment: string;
  public StrColonne: string;
}
